export default __webpack_public_path__ + "static/media/logo-spotify.88c0d071.svg";